import PropTypes from 'prop-types';
import React from 'react';
import { getFileExtension, getFilePathForView, isImagePreviewType } from './urls';

const getEmbeddableUrl = (url) => {
  if (typeof window === 'undefined') {
    return url
  }

  try {
    const parsedUrl = new URL(url, window.location.origin)
    const sameHostname = parsedUrl.hostname === window.location.hostname
    const differentPort = parsedUrl.port !== window.location.port

    if (sameHostname && differentPort && parsedUrl.pathname.startsWith('/api/')) {
      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`
    }
  }
  catch {
    return url
  }

  return url
}

const isTrustedAbsoluteUrl = (url) => {
  try {
    const parsedUrl = new URL(url)
    const apiUrl = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/`)

    return parsedUrl.origin === apiUrl.origin && parsedUrl.pathname.startsWith(apiUrl.pathname)
  }
  catch {
    return false
  }
}

export const PDFViewer = ({ path, type, project_id }) => {
  const normalizedType = (type || getFileExtension(path))?.toLowerCase()
  const isAbsoluteUrl = /^https?:\/\//i.test(path || '')
  const safePath = isAbsoluteUrl && isTrustedAbsoluteUrl(path) ? path : getFilePathForView(path, project_id)
  const viewUrl = getEmbeddableUrl(safePath)
  const viewerHeight = 'min(82vh, 900px)'
  const imageStyles = {
    display: 'block',
    width: 'auto',
    height: 'auto',
    maxWidth: 'calc(100vw - 64px)',
    maxHeight: 'calc(100vh - 180px)',
    objectFit: 'contain',
  }
  const embedStyles = {
    display: 'block',
    border: 0,
    width: '100%',
    height: viewerHeight,
    maxHeight: 'calc(100vh - 180px)',
  }

  if (normalizedType == "pdf") {
    return <iframe
      title="File preview"
      src={viewUrl}
      style={embedStyles}>
    </iframe>
  }
  else if (isImagePreviewType(normalizedType)) {
    return (
      <img src={viewUrl} alt="preview" style={imageStyles} />
    )
  }
  else {
    return (
      <object
        //type='application/pdf'
        data={viewUrl} // Replace with the path to your PDF file
        style={embedStyles}>
      </object>

    );
  }

}

PDFViewer.propTypes = {
  path: PropTypes.string,
  type: PropTypes.string,
  project_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

}
